"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TrackerMessage_1 = __importDefault(require("../TrackerMessage"));
const ErrorMessage_1 = __importDefault(require("./ErrorMessage"));
const Serializer_1 = require("../../../Serializer");
const VERSION = 2;
/* eslint-disable class-methods-use-this */
class ErrorMessageSerializerV2 extends Serializer_1.Serializer {
    toArray(errorMessage) {
        return [
            VERSION,
            TrackerMessage_1.default.TYPES.ErrorMessage,
            errorMessage.requestId,
            errorMessage.errorCode,
            errorMessage.targetNode,
        ];
    }
    fromArray(arr) {
        const [version, _type, requestId, errorCode, targetNode] = arr;
        return new ErrorMessage_1.default({
            version, requestId, errorCode, targetNode
        });
    }
}
exports.default = ErrorMessageSerializerV2;
TrackerMessage_1.default.registerSerializer(VERSION, TrackerMessage_1.default.TYPES.ErrorMessage, new ErrorMessageSerializerV2());
//# sourceMappingURL=ErrorMessageSerializerV2.js.map